import React, { useContext } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { FormFields } from '~/components/FormFields'
import { Form } from 'semantic-ui-react'
import SilageStepLayout from '../../SilageStepLayout'
import { StyledGroup } from '../style'
import OrganicFertilizers from './OrganicFertilizers'
import MineralFertilizers from './MineralFertilizers'
import { ClimaOptionsContext } from '..'

const SecondGrassStep: React.FC = () => {
  const { control } = useFormContext()
  const options = useContext(ClimaOptionsContext)
  const watchGrassLandAreas = useWatch({ control, name: 'grassSilage.grasslandGrazed' })

  function renderGrassAreaFields() {
    return <Form.Group>
      <FormFields.Input
        control={control}
        withoutAsterisk
        noErrorMessage
        rules={{
          required: true
        }}
        suffix={' ha'}
        label={'Beweidete Fläche'}
        name={'grassSilage.grazedArea'}
        placeholder={'in ha'}
        typeInput={'controled'}
      />
      <FormFields.Input
        control={control}
        withoutAsterisk
        noErrorMessage
        name={'grassSilage.dailyGrazingTime'}
        suffix=' Stunde(n)'
        label={'Tägliche Weidedauer'}
        placeholder={'in Studen'}
        rules={{
          required: true
        }}
        typeInput={'controled'}
      />
      <FormFields.Input
        control={control}
        withoutAsterisk
        label={'Weidetage je Jahr'}
        suffix=' Tag(e)'
        placeholder={'in Tage'}
        name={'grassSilage.grazingDaysPerYear'}
        noErrorMessage
        rules={{
          required: true
        }}
        typeInput={'controled'}
      />
      <FormFields.Input
        control={control}
        label={'Tierbesatz'}
        name={'grassSilage.animalDensity'}
        suffix=' GV/ha'
        placeholder={'in GV/ha'}
        withoutAsterisk
        noErrorMessage
        rules={{
          required: true
        }}
        typeInput={'controled'}
      />
    </Form.Group>
  }

  function renderForm() {
    return <>
      <FormFields.Checkbox
        defaultValue={0}
        checkboxValue={1}
        label={'Wurden die Grünlandflächen beweidet?'}
        control={control}
        name={'grassSilage.grasslandGrazed'}
      />
      {Boolean(watchGrassLandAreas) && renderGrassAreaFields()}
    </>
  }

  return (
    <SilageStepLayout
      infoText={`<div>Füllen Sie die Felder für <strong>beweidete Flächen</strong> aus, wobei die tierischen <strong>Nährstoffausscheidungen</strong> automatisch zur Düngung 
        hinzugerechnet werden. Wählen Sie <strong>alle ausgebrachten Düngemittel</strong> aus. Tragen Sie für jedes Düngemittel die 
        <strong>Ausbringmenge</strong> und die <strong>Ausbringtechnik</strong> ein und achten Sie dabei auf die korrekten <strong>Einheiten</strong>. Diese Daten sind wesentlich 
        für die Berechnung der <strong>Treibhausgasemissionen</strong> aus der Düngung (Lachgas, CO<sub>2</sub> aus Carbonat/Harnstoff, 
        Eissionen aus der Herstellung mineralischer Düngemittel).`}
    >
      <StyledGroup style={{ flexDirection: 'column', gap: '1em' }}>
        {renderForm()}
      </StyledGroup>
      <StyledGroup style={{ display: 'block', minHeight: 200 }}>
        <MineralFertilizers options={options} mineralKey='grassSilage.mineralFertilizers' />
      </StyledGroup>
      <StyledGroup style={{ display: 'block', minHeight: 200 }}>
        <OrganicFertilizers options={options} organicKey='grassSilage.organicFertilizers' />
      </StyledGroup>
    </SilageStepLayout>
  )
}

export default SecondGrassStep